export default __webpack_public_path__ + "img/XegmKRZc.41208ec5.svg";